export default "__VITE_ASSET__9f37e337__"